// logger.log(`revision #002`)
import { Auth0Provider } from '@auth0/auth0-react'
import {
  TooltipProvider,
  AutoTokenExpiryProvider,
  installBrowserTranslationDomPatch,
} from '@purepm/portals-ui'
import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { Toaster } from '@purepm/portals-ui'
import './index.css'
import { AnalyticsApplication, initializeAnalytics } from '@purepm/portals-ui'
import { auth0Config } from './lib/auth0'
import CONFIG from './lib/config'
import { LaunchDarklyProvider } from './providers/launch-darkly-provider'
import QueryProvider from './providers/query-provider'

installBrowserTranslationDomPatch()

// Define the future flags object
const future = { v7_startTransition: true, v7_relativeSplatPath: true }

initializeAnalytics({
  postHog: {
    projectKey: CONFIG.POSTHOG_PROJECT_KEY,
    host: CONFIG.POSTHOG_HOST,
  },
  applicationName: AnalyticsApplication.PORTAL_RESIDENT,
})

const AppWithSentry = Sentry.withProfiler(App)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter future={future}>
      <Auth0Provider {...auth0Config}>
        <AutoTokenExpiryProvider>
          <LaunchDarklyProvider>
            <QueryProvider>
              <TooltipProvider delayDuration={0}>
                <AppWithSentry />
                <Toaster />
              </TooltipProvider>
            </QueryProvider>
          </LaunchDarklyProvider>
        </AutoTokenExpiryProvider>
      </Auth0Provider>
    </BrowserRouter>
  </StrictMode>,
)
